import { Capacitor, registerPlugin } from '@capacitor/core';

export interface ActiveAppleSubscription {
  hasActive: boolean;
  productId?: string;
  transactionId?: string;
  originalTransactionId?: string;
  expirationDate?: number;
}

interface AppleOfferCodePlugin {
  present(): Promise<void>;
  getActiveSubscription(): Promise<ActiveAppleSubscription>;
}

const AppleOfferCode = registerPlugin<AppleOfferCodePlugin>('AppleOfferCode', {
  web: {
    present: async () => undefined,
    getActiveSubscription: async () => ({ hasActive: false }),
  },
});

export const appleOfferCode = {
  isSupported(): boolean {
    return Capacitor.getPlatform() === 'ios';
  },
  async present(): Promise<void> {
    if (!this.isSupported()) return;
    await AppleOfferCode.present();
  },
  async getActiveSubscription(): Promise<ActiveAppleSubscription> {
    if (!this.isSupported()) return { hasActive: false };
    return AppleOfferCode.getActiveSubscription();
  },
};
